import React from "react";

import classes from "./Backdrop.css";
/**
 * @desc backdrop in modals
 * @param props
 * @return null
 */
const backdrop = props =>
  props.show ? (
    <div className={"backdrop " + props.className} onClick={props.clicked} />
  ) : null;

export default backdrop;



// WEBPACK FOOTER //
// ./src/components/UI/Backdrop/Backdrop.js